import axios from 'axios';
import { formatApiErrorMessage } from './errors';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Normalize backend errors (FastAPI detail can be object/array)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.data?.detail !== undefined) {
      const formatted = formatApiErrorMessage(error.response.data.detail);
      error.response.data.detail = formatted;
      error.message = formatted;
    } else if (error?.response?.data) {
      error.message = formatApiErrorMessage(error.response.data, error.message);
    }
    return Promise.reject(error);
  }
);

// API functions
export const clientsAPI = {
  getAll: () => api.get('/clients'),
  getOne: (id) => api.get(`/clients/${id}`),
  create: (data) => api.post('/clients', data),
  reassign: (clientId, employeeId) => api.patch(`/clients/${clientId}/reassign?new_employee_id=${employeeId}`),
  getCredentials: (clientId) => api.get(`/clients/${clientId}/credentials`),
};

export const casesAPI = {
  getAll: () => api.get('/cases'),
  getOne: (id) => api.get(`/cases/${id}`),
  update: (id, data) => api.patch(`/cases/${id}`, data),
};

export const messagesAPI = {
  getByClient: (clientId) => api.get(`/messages/client/${clientId}`),
  send: (data) => api.post('/messages', data),
  getUnreadCount: () => api.get('/messages/unread'),
};

export const visitorsAPI = {
  getAll: () => api.get('/visitors'),
  create: (data) => api.post('/visitors', data),
  checkout: (id) => api.patch(`/visitors/${id}/checkout`),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

export const employeesAPI = {
  getAll: () => api.get('/employees'),
  toggleStatus: (id) => api.patch(`/employees/${id}/toggle-status`),
};

export const workflowsAPI = {
  getAll: () => api.get('/workflows'),
};

export const paymentsAPI = {
  declare: (data) => api.post('/payments/declare', data),
  getPending: () => api.get('/payments/pending'),
  getHistory: () => api.get('/payments/history'), // Manager/SuperAdmin
  getClientHistory: () => api.get('/payments/client-history'), // Client only
  confirm: (id, data) => api.patch(`/payments/${id}/confirm`, data),
  reassignConsultant: (prospectId, data) => api.patch(`/contact-messages/${prospectId}/reassign-consultant`, data),
  assignConsultation: (prospectId, data) => api.patch(`/contact-messages/${prospectId}/assign-consultant`, data),
};

export default api;
